import { AccountRoleType } from './accountRoleType';
import { Address } from '@unleashed/models/address';

export interface User {
  id?: number;
  hashCode?: string;
  accountId?: number;
  accountRoles?: AccountRoleType[];
  firstName?: string;
  middleName?: string;
  lastName?: string;
  address?: Address;
  fullName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  dateOfBirth?: Date;
  imageUrl?: string;
  accountSourceId?: number;
  isRegistered?: boolean;
  // UI-only fields
  loggedIn?: boolean;
  impersonated?: boolean;
  // [STORE-507] Set by a vendor payment link (`showConfirmation=true`): after an impersonated payment show the
  // confirmation page instead of the staff redirect to the admin site.
  showConfirmation?: boolean;
}
